import React, {useEffect, useRef, useState} from "react";

// components
import { mapStateToProps } from "../../store/helpers/mapState";
import { mapDispatchToProps } from "../../store/helpers/mapDispatch";
import { connect } from "react-redux";
import {
    Alert,
    Badge,
    Box,
    Button,
    Chip,
    CircularProgress,
    Dialog, DialogActions, DialogContent, DialogTitle, IconButton,
    Tab,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Tabs
} from "@mui/material";
import a11yProps from "../../helpers/ay-props";
import TabPanel from "../../helpers/TabPanel";
import { useHistory, useParams } from "react-router";
import {categoryValues, getError, getSuccessMessage} from "../../store/helpers/common_functions";
import PageLoading from "../../helpers/PageLoading";
import moment from "moment";
import { Download } from "@mui/icons-material";
import { downloadUrl } from "Shared/commonFunction";
import classes from './profile.module.css';
import FormDialog from "../../helpers/FormDialog";
import BorderColorIcon from '@mui/icons-material/BorderColor';
import { StyledTableRow } from "../../helpers/CustomMenu";
import Meeting from "../meeting/meeting"
import { getAllMeetingList } from "store/Meeting/actions";
import Add from "@mui/icons-material/Add";
import { GrAdd } from "react-icons/gr";
import { VscAdd } from "react-icons/vsc";
import { MdPictureAsPdf } from "react-icons/md";
import { TbFileCertificate } from "react-icons/tb";
import { FaCertificate } from "react-icons/fa";
import { SlOptionsVertical } from "react-icons/sl";
import jwtDecode from "jwt-decode";
import BasicMenu from "../../helpers/menu";
import DeleteDialog from "helpers/DeleteDialog";
import {ResourceFormDialog} from "./Resource";
import {errorToast, successToast} from "../../helpers/Notification";
import {isImage} from "../../helpers/Common_functions";
import {ProjectWorkedOn} from "./ResourceProfile";





function LoggedUserProjects({
    FetchDetails, loggedUser,SetSelectedMenu }) {
    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState();
    const [info, setInfo] = React.useState();
    const [project, setProject] = React.useState();



    useEffect(()=>{
        SetSelectedMenu({
            menu:"my-projects",
            title:"My Projects"
        })
    },[]);


    const loadData = async () => {
        setLoading(true);
        setError(null);
        const resp = await FetchDetails(`/api/profile/details`);
        setLoading(false);
        if (resp.status) {
            let inf0 = { ...project, projects: resp.data?.projects ?? [] };
            setProject(inf0)
            setInfo(resp.data);
        } else {
            setError(getError(resp));
        }
        return resp;
    }

    useEffect(() => {
        if(loggedUser){
            loadData().then();
        }
    }, [loggedUser]);


    return (loading && !info) || error || !info ? <PageLoading error={loading ? null : error} onRefresh={loadData} /> : <div className="flex flex-wrap">
        <div className="w-full lg:w-12/12 px-4">
            <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg border-0">
                <div className="rounded bg-white mb-0 px-0 py-0 overflow-hidden">
                    <ProjectWorkedOn project={project?.projects} />
                </div>
            </div>
        </div>
    </div >;
}

export default connect(mapStateToProps, mapDispatchToProps)(LoggedUserProjects);
